/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BenchmarkRunUpdatedMessage } from '../../models/benchmark-run-updated-message';

export interface GetnotificationsBenchmarkRunUpdatedSchema$Params {
}

export function getnotificationsBenchmarkRunUpdatedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsBenchmarkRunUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkRunUpdatedMessage>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsBenchmarkRunUpdatedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BenchmarkRunUpdatedMessage>;
    })
  );
}

getnotificationsBenchmarkRunUpdatedSchema.PATH = '/api/hubs/notifications/BenchmarkRunUpdated';
